<template>
  <div class="table1-container">
    <div class="table1-title" v-html="content.title"></div>
    <div class="table1-box">
      <div class="table1-top">
        <div
          class="top-item"
          @click.stop="(e)=> {
            findChapterFrom(e);
            e.stopPropagation();
          }"
        >
          <div class="top-item-title">班级</div>
          <el-input class="top-item-input" v-model="formData.className" placeholder=""></el-input>
        </div>
        <div
          class="top-item"
          @click.stop="(e)=> {
            findChapterFrom(e);
            e.stopPropagation();
          }"
        >
          <div class="top-item-title">组号</div>
          <el-input class="top-item-input" v-model="formData.groupNumber" placeholder=""></el-input>
        </div>
        <div
          class="top-item"
          @click.stop="(e)=> {
            findChapterFrom(e);
            e.stopPropagation();
          }"
        >
          <div class="top-item-title">指导教师</div>
          <el-input class="top-item-input" v-model="formData.teacher" placeholder=""></el-input>
        </div>
      </div>
      <div class="table1-bottom">
        <div class="table1-bottom-title">小组成员</div>
        <div class="botton-item botton-item-leader" @click.stop="editTable($event, 'leader')">
          <div class="item-left">组长</div>
          <div class="item-center" v-if="formData.leader.name">
            <div class="item-center-top">
              <span class="item-center-name">{{ formData.leader.name }}</span>(学号：{{ formData.leader.studentCode }})
            </div>
            <div class="item-center-content">任务分工：{{ formData.leader.task }}</div>
          </div>
          <div class="item-empty" v-else>点击填写组长信息和任务分工</div>
          <div class="item-right" @click.stop="clearHandle($event, 'leader')">
            <div class="item-right-text">清空</div>
          </div>
        </div>
        <div class="bottom-member-list">
          <div class="botton-item" v-for="(item, index) in formData.studentList" :key="index" @click.stop="editTable($event, 'student', index)">
            <div class="item-left">组员</div>
            <div class="item-center" v-if="item.name">
              <div class="item-center-top">
                <span class="item-center-name">{{ item.name }}</span>(学号：{{ item.studentCode }})
              </div>
              <div class="item-center-content">任务分工：{{ item.task }}</div>
            </div>
            <div class="item-empty" v-else>点击填写组员信息和任务分工</div>
            <div class="item-right" @click.stop="clearHandle($event, 'student', index)">
              <div class="item-right-text">清空</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <table1Dialog :visible="table1Visible" :content="dialogContent" @submitForm="submitForm" @dialogClose="table1Hide"></table1Dialog>
  </div>
</template>

<script>
import table1Dialog from "./table1-dialog.vue";
export default {
  name: "workOrderTable1",
  inject: {
    findChapterFrom: {
      default: () => {},
    },
  },
  components: {
    table1Dialog
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      table1Visible: false,
      formData: {
        className: '',
        groupNumber: '',
        teacher: '',
        leader: {
          name: '',
          studentCode: '',
          task: '',
        },
        studentList: [
          {
          name: '',
            studentCode: '',
            task: '',
          },
          {
            name: '',
            studentCode: '',
            task: '',
          },
          {
            name: '',
            studentCode: '',
            task: '',
          },
          {
            name: '',
            studentCode: '',
            task: '',
          },
          {
            name: '',
            studentCode: '',
            task: '',
          },
        ],
      },
      activeType: 'leader',
      activeIndex: 0,
      dialogContent: {},
    }
  },
  methods: {
    table1Hide() {
      this.table1Visible = false;
    },
    editTable(e, type, index) {
      this.activeType = type;
      if(type === 'leader') {
        this.dialogContent = this.formData.leader;
      }else if(type === 'student'){
        this.activeIndex = index;
        this.dialogContent = this.formData.studentList[index];
      }
      this.table1Visible = true;
      this.findChapterFrom(e);
    },
    clearHandle(e, type, index) {
      if(type === 'leader') {
        this.formData.leader.name = '';
        this.formData.leader.studentCode = '';
        this.formData.leader.task = '';
      }else if(type === 'student'){
        this.$set(this.formData.studentList[index], 'name', '');
        this.$set(this.formData.studentList[index], 'studentCode', '');
        this.$set(this.formData.studentList[index], 'task', '');
      }
      this.findChapterFrom(e);
    },
    submitForm(data) {
      if(this.activeType === 'leader') {
        this.formData.leader.name = data.name;
        this.formData.leader.studentCode = data.studentCode;
        this.formData.leader.task = data.task;
      }else if(this.activeType === 'student'){
        this.$set(this.formData.studentList[this.activeIndex], 'name', data.name);
        this.$set(this.formData.studentList[this.activeIndex], 'studentCode', data.studentCode);
        this.$set(this.formData.studentList[this.activeIndex], 'task', data.task);
      }
    },
    submitHandle() {
      return {table1: 1111}
    },
  }
}
</script>

<style lang="scss" scoped>
.table1-container{
  width: 660rem;
  margin-left: 16rem;
  margin-top: 30rem;

  .table1-title{
    text-align: center;
    font-size: 20rem;
    color: #666;
  }

  .table1-box{
    margin-top: 10rem;
    border: 1rem solid #999;
    padding: 20rem 10rem 30rem;
    border-radius: 6rem;

    .table1-top{
      padding: 0 10rem 26rem;
      border-bottom: 1rem dashed #E3E3E3;
      display: flex;
      justify-content: space-between;

      .top-item{

        .top-item-title{
          text-align: center;
          font-size: 20rem;
          color: #999;
        }

        .top-item-input{
          font-size: 28rem;
          color: #333;
          border-radius: 6rem;
          text-align: center;

          /deep/.el-input__inner{
            line-height: 56rem;
            height: 56rem;
            border: 1rem solid #89C2F0;
            background: #DBECFA;
            padding: 0 12rem;
            text-align: center;

            &:focus{
              background: #fff;
            }
          }
        }

        &:nth-child(1) {
          width: 340rem;
        }
        &:nth-child(2) {
          width: 100rem;
        }
        &:nth-child(3) {
          width: 140rem;
        }
      }
    }
  }

  .table1-bottom{
    padding: 0 10rem;

    .table1-bottom-title{
      font-size: 20rem;
      color: #999;
      line-height: 30rem;
      margin-top: 20rem;
    }

    .botton-item{
      border: 1rem solid #89C2F0;
      display: flex;
      min-height: 130rem;
      border-radius: 6rem;
      overflow: hidden;

      .item-left{
        flex: 0 0 36rem;
        width: 36rem;
        color: #1457B6;
        font-size: 20rem;
        line-height: 48rem;
        background: #89C2F0;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .item-center{
        flex: 1;
        padding: 20rem;

        .item-center-top{
          font-size: 24rem;
          color: #666;
          line-height: 48rem;
          margin-bottom: 8rem;

          .item-center-name{
            user-select: none;
            font-size: 28rem;
            color: #333;
          }
        }

        .item-center-content{
          font-size: 24rem;
          color: #666;
          line-height: 28rem;
        }
      }

      .item-empty{
        flex: 1;
        font-size: 24rem;
        color: #999;
        text-align: center;
        line-height: 130rem;
      }

      .item-right{
        flex: 0 0 50rem;
        width: 50rem;
        background: #DBECFA;
        font-size: 18rem;
        text-align: center;
        color: #3F83E4;
        display: flex;
        align-items: center;
        justify-content: center;

        .item-right-text{
          padding-top: 36rem;
          position: relative;

          &:before{
            content: '';
            width: 22rem;
            height: 22rem;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            background: url(~@/assets/images/books/book1/workOrder/delete-icon.png) center center no-repeat;
            background-size: contain;
          }
        }
      }
    }

    .botton-item-leader{
      margin: 10rem auto 20rem;
      
      .item-left{
        font-weight: bold;
      }
      
      .item-center{
        .item-center-top{
          .item-center-name{
            font-weight: bold;
          }
        }
      }
    }

    .bottom-member-list{
      border: 1rem solid #89C2F0;
      border-radius:6rem;
      overflow: hidden;

      .botton-item{
        border: 0;
        border-bottom: 1rem solid #89C2F0;
        display: flex;
        min-height: 130rem;
        border-radius: 0;

        &:last-child{
          border: 0;
        }
      }
    }
  }
}
</style>